export default "<!-- Vue Component -->\n\n<template v-slot:items=\"props\">\n  <td>{‌{ props.item.name }‌}</td>\n</template>\n";